import mixins from 'vue-typed-mixins';

import { 償却ListItem } from '@/classes/service/分析計画/償却Type';

import 償却ListMixin from '@/entries/user/mixins/償却ListMixin';

export default mixins(償却ListMixin).extend({
  name: 'M償却EditableListMixin',

  data(): {
    selectedItem: 償却ListItem | null;
  } {
    return {
      selectedItem: null,
    };
  },

  methods: {
    select償却ForEdit(item: 償却ListItem): void {
      this.selectedItem = item;
    },
    clear償却EditRow() {
      this.selectedItem = null;
    },
    clearAndLoad償却List() {
      this.clear償却EditRow();
      this.load償却List();
    },
  },
});
